/**
 * Default settings
 *
 * Values are in constants.js
 */

import constants from './constants.js'

const settings = {
  list: [{
    category: 'dashboard',
    key: 'alarmsRefresh',
    value: constants.alarmsRefresh
  }, {
    category: 'dashboard',
    key: 'healthRefresh',
    value: constants.healthRefresh
  }, {
    category: 'dashboard',
    key: 'remoteShellActivation',
    value: constants.remoteShellActivation
  }, {
    category: 'dashboard',
    key: 'tilesServerUrl',
    value: constants.tilesServerUrl
  }, {
    category: 'dashboard',
    key: 'tilesServerAttribution',
    value: constants.tilesServerAttribution
  }]
}

// Export module
export default settings
